import type { McpGrantScope } from '@/lib/api';

export const queryKeys = {
  auth: {
    me: ['auth', 'me'] as const,
  },
  company: {
    info: ['company', 'info'] as const,
  },
  config: {
    root: ['config'] as const,
  },
  settings: {
    root: ['settings'] as const,
  },
  admins: {
    list: ['admins', 'list'] as const,
    roster: ['admins', 'roster'] as const,
  },
  mcpOAuth: {
    client: (params: Record<string, string>) => ['mcp-oauth', 'client', params] as const,
    /** Both scopes share this prefix, so one invalidation refreshes either list. */
    grantsAll: ['mcp-oauth', 'grants'] as const,
    grants: (scope: McpGrantScope) => ['mcp-oauth', 'grants', scope] as const,
  },
  connectedServices: ['connected-services'] as const,
  widget: {
    all: ['widget'] as const,
    data: (id: string, filters: Record<string, string>) => ['widget', id, filters] as const,
  },
  accessLegitimacy: {
    all: ['access-legitimacy'] as const,
    // `params` already carries sorted arrays + the debounced search, so the
    // serialized key is stable and toggling back to a prior filter combination
    // hits the cache.
    grid: (params: unknown) => ['access-legitimacy', 'grid', params] as const,
  },
} as const;
